<template>
  <div class="RuleValue">
    <div v-if="ruleKeyType === 'lookup'" class="select-wrapper">
      <multiselect 
        v-model="value" 
        label="name"
        selectedLabel=""
        track-by="value"
        :options="lookups" 
        :close-on-select="true"
        :multiple="ruleOperator === 'in'"
        @input="change"
        placeholder="Pick a value"
        openDirection="bottom"
      />
      <span
        class="clear-select"
        @click="clearFilter"
        v-if="ruleOperator !== 'in'"
      >
        &nbsp;&times;
      </span>
    </div>
    <div 
      v-else-if="ruleKeyType === 'date'"
      class="RuleValue__date">
      <DateFilter 
        :filter="filter"
        :cellKey="ruleKey"
        :isComputedExpression="isComputedExpression"
      />
      <a
        v-if="value && value.type"
        href="#"
        @click.prevent="clearFilter"
        v-b-tooltip
        title="Clear Filter"
      >
        <icon name="remove" />
      </a>
    </div>
    <div 
      v-else-if="ruleKeyType === 'checkbox'"
      class="RuleValue__checkbox">
      <CheckboxFilter 
        :filter="filter"
        :cellKey="ruleKey" />
      <a
        v-if="typeof value === 'boolean'"
        href="#"
        @click.prevent="clearFilter"
        v-b-tooltip
        title="Clear Filter"
      >
        <icon name="remove" />
      </a>
    </div>
    <div 
      v-else-if="ruleKeyType === 'user'"
    >
      <UserFilter
        :filter="filter"
        :cellKey="ruleKey"
      />
    </div>
    <input 
      v-else
      type="text" 
      class="form-control input-sm" 
      v-model="value" 
      placeholder="value" 
      @input="debouncedSave" 
      @change="change" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash';
import utils from "@/helpers/utils";
import DateFilter from '../../DataGrid/controls/filters/Date'
import CheckboxFilter from '../../DataGrid/controls/filters/Checkbox'
import UserFilter from '../../DataGrid/controls/filters/User'
import db from '@/services/db'

export default {
  props: ['ruleValue','ruleOperator','ruleKey','ruleExpression','dataProvider','isComputedExpression'],
  components: {
    DateFilter,
    CheckboxFilter,
    UserFilter
  },
  data () {
    return {
      value: this.ruleValue,
      ruleKeyType: null,
      lookups: null,
      filter: {}
    }
  },
  mounted() {
    this.updateRuleKeyLookups()

    if (!this.isComputedExpression && this.ruleExpression) {
      const value = utils.evalExpression(this.ruleValue);
      
      if (this.ruleKeyType === 'lookup') {
        this.value = this.lookups.filter(lookup => Array.isArray(value) ? value.includes(lookup.value) : value === lookup.value)
      } else {
        this.value = value;
      }
    }
  },
  watch: {
    ruleValue(value) {
      this.value = value
      this.updateFilterVal()
    },
    ruleKey() {
      this.updateRuleKeyLookups()
    },
    filter: {
      handler() {
        if (
          this.ruleKeyType === 'date' ||
          this.ruleKeyType === 'checkbox' ||
          this.ruleKeyType === 'user'
        ) {
          this.value = this.filter[this.ruleKey]
          this.change()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState([
      "dataGrid_options"
    ]),
    debouncedSave: function() {
      return debounce(this.change, 500);
    }
  },
  methods: {
    change() {
      this.$emit('change', this.value)
    },
    clearFilter() {
      this.filter = {}
      this.value = null
      this.$emit('filterItemRemove', this.ruleKey)
      this.change()
    },
    updateFilterVal() {
      this.filter = {
        [this.ruleKey]: this.ruleValue
      }
    },
    updateRuleKeyLookups() {
      this.lookups = null;
      this.ruleKeyType = null;
      if(this.ruleKey) {
        this.updateFilterVal()
        const options = this.dataGrid_options[this.dataProvider] || {}
        const meta = (options.meta && options.meta[this.ruleKey]) || {}
        this.ruleKeyType = meta.type;
        if (meta.type === 'lookup') {
          this.lookups = this.getLookups(meta.lookUpTable)
          this.lookups.sort(function(a, b){
            if(a.name < b.name) { return -1; }
            if(a.name > b.name) { return 1; }
            return 0;
          })
        } 
      }
    },
    getLookups (lookUpTable) {
      const lookups = []
      const {
        displayColumn,
        source,
        storageType
      } = this.dataGrid_options[lookUpTable]
      const getModel = db.dataGrid.data.getReadModel(storageType)
      const tData = getModel(source)

      for (let rowKey in tData) {
        const row = tData[rowKey]
        lookups.push({
          value: rowKey,
          name: this.$getDataGridVal(row[displayColumn])
        });
      }

      return lookups
    },
    $getDataGridVal (cell) {
      if (window.$getDataGridVal) {
        return window.$getDataGridVal(cell);
      } else {
        return cell.value
      }
    }
  }
}
</script>

<style lang="scss">
.RuleValue {
  width: 100%;

  &__date,
  &__checkbox {
    display: flex;
  }

  .dg-dateFilter {
    padding-top: 0px;
  }
  .dg-datePicker__input input {
    display: none;
  }
  .select-wrapper {
    display: flex;
    align-items: center;
  }
  .clear-select {
    cursor: pointer;
  }
}
</style>
